import { IAppLoaderConfig } from './app-loader-config.interface';

export class AppLoaderConfig implements IAppLoaderConfig {
  public backdropBorderRadius?: string;
  public backdropBackgroundColour?: string;
  public fullScreenBackdrop?: boolean;
  public animationType?: string;
  public primaryColour?: string;
  public secondaryColour?: string;
  public tertiaryColour?: string;
  [key: string]: string | boolean | undefined;

  constructor(config: IAppLoaderConfig = {}) {
    this.backdropBorderRadius = config.backdropBorderRadius;
    this.backdropBackgroundColour = config.backdropBackgroundColour;
    this.fullScreenBackdrop = config.fullScreenBackdrop;
    this.animationType = config.animationType;
    this.primaryColour = config.primaryColour;
    this.secondaryColour = config.secondaryColour;
    this.tertiaryColour = config.tertiaryColour;
  }
}

export const appLoaderAnimationTypes = {
  chasingDots: 'chasing-dots',
  none: 'none',
  threeBounce: 'three-bounce',
};
